import Steps from './components/steps';
import './App.css';


function App() {
  return (
    <div className="App">
      <Steps></Steps>
    </div>
  );
}

export default App;
